import React from 'react';
import { connect } from 'react-redux';

const ShowSignupButton = ({screen, showSignUpScreen}) => {
  return (screen === 'signin') ?
          <div className="sign-up" onClick={() => showSignUpScreen()}>
            <a href="javascript:void(0)" className="sign-up__link">Sign up</a>
          </div> : <div></div>;
}

const mapStateToProps = ({formLoginReducers}) => {
  return {
    screen: formLoginReducers.screen
  }
}

const mapDispatchToProps = (dispatch, props) => {
  return {
    showSignUpScreen: (e) => {
      dispatch({type: 'SCREEN', screen: 'signup', initialLoad: false});
      dispatch({type: 'ERRORS', errors: {}});
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ShowSignupButton);


// WEBPACK FOOTER //
// ./app/javascript/pages/page/form_login_modal/signup_button.js